import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ProfileInformation } from './information';
import { OwnChassisList } from './chassis-list';
import { getChassis } from '@/actions';
import LoadingV2 from '@/components/Loading';

export const Profile = () => {
  const user = useSelector((state) => state.reducer.user);
  const [chassisList, setChassisList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        // Wait for user data to be available and fetch chassis data
        if (user) {
          const chassis = await getChassis();
          const chassisArray = Array.isArray(chassis)
            ? chassis
            : Object.values(chassis);
          setChassisList(chassisArray);
        }
      } catch (error) {
        console.error('Error fetching chassis:', error);
        setChassisList([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [user]);

  if (loading || !user) return <LoadingV2 />;

  return (
    <div className="md:grid space-y-4 lg:space-y-0 grid-cols-1 lg:grid-cols-12 gap-12">
      <div className="lg:col-span-8">
        <ProfileInformation user={user} />
      </div>
      <div className="lg:col-span-4">
        <OwnChassisList
          chassisList={chassisList}
          setChassisList={setChassisList}
        />
      </div>
    </div>
  );
};
